const valor = (...candidatos) => {
  for (let i = 0; i < candidatos.length; i += 1) {
    const actual = candidatos[i];
    if (actual !== undefined && actual !== null && actual !== "") {
      return actual;
    }
  }
  return "";
};

const formatearDetalle = (detalle) => {
  if (detalle === undefined || detalle === null || detalle === "") {
    return "";
  }
  if (typeof detalle === "string") {
    return detalle;
  }
  try {
    return JSON.stringify(detalle);
  } catch (error) {
    return String(detalle);
  }
};

export const extraerListaAuditLog = (payload) => {
  if (Array.isArray(payload)) {
    return {
      registros: payload,
      total: payload.length,
      parqueaderos: [],
      terminales: [],
    };
  }
  if (!payload || typeof payload !== "object") {
    return { registros: [], total: 0, parqueaderos: [], terminales: [] };
  }

  const registros =
    payload.data ||
    payload.items ||
    payload.records ||
    payload.rows ||
    payload.result ||
    [];

  const lista = Array.isArray(registros) ? registros : [];
  const total =
    typeof payload.total === "number" ? payload.total : lista.length;
  const parqueaderos = Array.isArray(payload.parqueaderos)
    ? payload.parqueaderos
    : [];
  const terminales = Array.isArray(payload.terminales)
    ? payload.terminales
    : [];

  return { registros: lista, total, parqueaderos, terminales };
};

export const normalizarRegistroAuditLog = (row = {}) => ({
  id: valor(row.id, row.idAuditLog, row.id_audit_log, row.auditLogId),
  usuario: valor(
    row.usuario,
    row.email,
    row.userEmail,
    row.usuarioEmail,
    row.usuario_email
  ),
  accion: valor(row.accion, row.action, row.operacion, row.tipo),
  fecha: valor(
    row.fecha,
    row.createdAt,
    row.created_at,
    row.fechaCreacion,
    row.fecha_creacion
  ),
  entidad_id: valor(
    row.entidad_id,
    row.entidadId,
    row.registroId,
    row.idRegistro,
    row.recordId
  ),
  terminal: valor(
    row.terminal,
    row.codTerminal,
    row.cod_terminal,
    row.codigoTerminal
  ),
  detalle: formatearDetalle(
    valor(row.detalle, row.descripcion, row.payload, row.datos, row.cambios)
  ),
});

export const ordenarPorFechaDesc = (registros) =>
  [...registros].sort((a, b) => {
    const fechaA = a.fecha ? new Date(a.fecha).getTime() : 0;
    const fechaB = b.fecha ? new Date(b.fecha).getTime() : 0;
    return fechaB - fechaA;
  });
